// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mb-12[data-v-73d7d5ad]{margin-bottom:12rem!important}", "",{"version":3,"sources":["webpack://./resources/js/tenant/Components/View/Product/Unit/UnitCreateEditModal.vue"],"names":[],"mappings":"AAEA,wBACI,6BADJ","sourcesContent":["\n\n.mb-12 {\n    margin-bottom: 12rem !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
